import { camelize } from 'casing'
import { v4 as uuid4 } from 'uuid'
import { awsMarketplaceProductLink } from '../../../../common/utils/constants'
import type { BWAProduct, BWAProductGet, ListingCardData } from '../types'

export const transformDataFromGet = (data: Record<string, unknown>) => {
  const { product, id, ...rest } = data
  const updatedProduct: BWAProduct[] =
    Object.keys(product as BWAProductGet).map((key: string) => {
      return {
        ...(product as BWAProductGet)[key],
        url: `${awsMarketplaceProductLink}/${key}`,
        isOpen: true,
        uniqueId: uuid4(),
        isLoading: false,
      }
    }) || []
  if (updatedProduct.length === 0) {
    updatedProduct.push({
      uniqueId: String(uuid4()),
      url: '',
      isOpen: true,
      isLoading: false,
    }) as unknown as BWAProduct[]
  }
  return {
    ...camelize(rest),
    product: updatedProduct,
    integrationId: id,
  } as ListingCardData
}
